export default Object.freeze({
  MANDIBULAIRE: 'Mandibulaire',
  MAXIMILLAIRE: 'Maxillaire',
  COMPLETE: 'Mandibulaire + Maxillaire',
});
